import React from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, CardTitle, CardText, Container, Row, Col } from "reactstrap";
import projectData from "../data/projects.json";

const Projects = () => {
  return (
    <Container className="projects-container">
      <h1 className="page-title">Projects</h1>
      <Row>
        {projectData.map((project, index) => (
          <Col md={6} lg={4} key={index} className="mb-4">
            <Link to={`/projects/${project.name}`} style={{ textDecoration: "none" }}>
              <Card className="project-card h-100">
                <CardBody>
                  <CardTitle tag="h5">{project.title}</CardTitle>
                  <CardText>{project.description}</CardText>
                </CardBody>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Projects;
